var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-up-block',{attrs:{"upperTitle":true,"image":_vm.image,"topSubTitle":_vm.topSubTitle,"title":_vm.title,"description":'',"buttonText":_vm.buttonText,"button":_vm.button,"checks":_vm.showChecks ? _vm.checks : []}})
}
var staticRenderFns = []

export { render, staticRenderFns }